var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Back Button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.8592771,13.6881834 C20.0462891,13.8586338 20.0466817,14.1409707 19.8617933,14.3098332 L16.0996012,17.8665204 C15.9183792,18.0442266 15.6170586,18.0442266 15.4307734,17.8681148 C15.2508151,17.6983809 15.2511933,17.4168676 15.4316643,17.2403141 L18.3963495,14.4427785 L8.4668936,14.4427785 C8.20773505,14.4427785 8,14.2427938 8,13.9971383 C8,13.7526488 8.20653268,13.5572575 8.46701577,13.5568598 L18.3964933,13.5568599 L15.4307734,10.7531053 C15.2509132,10.583464 15.2509132,10.3019186 15.430673,10.1319759 C15.6167866,9.95602641 15.9171084,9.95577502 16.0987253,10.1326202 L19.8592771,13.6881834 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glide_-Footer-Component",
    transform: "translate(-23.000000, -37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Back-Button",
    transform: "translate(24.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "#35A4F2",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    transform: "translate(14.000000, 14.000000) rotate(-180.000000) translate(-14.000000, -14.000000) "
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    stroke: "#2AA0F2",
    strokeWidth: 0.5,
    fill: "#2DA1F2",
    fillRule: "nonzero",
    transform: "translate(14.000000, 14.000000) rotate(-180.000000) translate(-14.000000, -14.000000) ",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.47f089d5.svg";
export { ForwardRef as ReactComponent };